import { Card } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { DateUtils } from '../../../utils/dateUtils';
import { AppUtils } from '../../../utils/appUtils';

const ChartDataByDailyPatient = ({ ChartDataByDailyPatient }) => {
  const [chartLabels, setChartLabels] = useState([]);
  const [seriesData, setSeriesData] = useState([]);

  const buildChartData = () => {
    const labels = [];
    const values = [];

    for (let i = 29; i >= 0; i--) {
      const dateBeforeDays = DateUtils.getDateMilliseconds(DateUtils.getDaysBeforeBSDate(i));
      const formattedDate = AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(dateBeforeDays));
      labels.push(formattedDate);
      values.push(ChartDataByDailyPatient["MONTHLY_DATA"][dateBeforeDays] || 0);
    }

    setChartLabels(labels);
    setSeriesData([{ name: 'सेवाग्राहीहरुको', data: values }]);
  };

  useEffect(() => {
    if (ChartDataByDailyPatient?.MONTHLY_DATA) {
      buildChartData();
    }
  }, [ChartDataByDailyPatient]);

  const chartOptions = {
    chart: {
      type: 'area',
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      type: 'category',
      categories: chartLabels,
      title: {
        text: "सेवाग्राही आएको मिति",
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
      },
    },
    yaxis: {
      title: {
        text: "जम्मा सेवाग्राही संख्या",
      },
    },
    title: {
      text: "अन्तिम ३० दिनमा आएका सेवाग्राहीहरुको विवरण",
      align: "center",
      style: {
        fontSize: "15px",
      },
    },
  };

  return (
    <Card>
      <Chart options={chartOptions} series={seriesData} type="area" height={350} />
    </Card>
  );
};

export default ChartDataByDailyPatient;